import { DelioLabels } from "./class/DelioLabels";
import { Globals } from "./globals/variables";
import { iniciarPagina, initToggle } from "./utils/utlis";
(async () => {
  const delioLabels = new DelioLabels();

  document.addEventListener("DOMContentLoaded",async ()=>{
    initToggle();

    if(document.getElementById('contenedor-ofertas')) {
      await iniciarPagina().then(()=>{
        delioLabels.loadDelioLibs(Globals.DelioOneClick.init, Globals.idTagD1C);
        delioLabels.loadLabels();

        document.querySelector('.btn-ver-ofertas').addEventListener('click', () => {
          const seccion = document.querySelector('#contenedor-ofertas');
          const offset  = window.innerWidth > 991 ? 80: 20; // altura aproximada de tu header
        
          window.scrollTo({
            top: seccion.offsetTop - offset,
            behavior: 'smooth'
          });
        });

      })
    }
    else {
      delioLabels.loadDelioLibs(Globals.DelioOneClick.init, Globals.idTagD1C);
      delioLabels.loadLabels();
    }
  })
})();

